import type { ModuleConfig } from '../types/config';
import API_CONFIG from './api-config';
import { OPENAPI_PATH } from './api-paths';

/** Super-admin shell route — not part of tenant `platform_modules`. */
export const SUPER_ADMIN_MODULE: ModuleConfig = {
  id: 'super-admin',
  name: 'Super Admin',
  icon: 'Shield',
  path: '/super-admin',
  enabled: true,
  component: 'SuperAdmin',
  permissions: ['super_admin'],
  settings: {
    description: 'Platform overview: tenant subscriptions, module access, fee plans, and collections.',
  },
};

/** Dev-only API explorer — not stored in tenant navigation catalog. */
export const DEV_API_EXPLORER_MODULE: ModuleConfig = {
  id: 'api',
  name: 'API',
  icon: 'Code',
  path: '/api',
  enabled: true,
  component: 'ApiExplorer',
  permissions: ['admin'],
  settings: {
    baseUrl: API_CONFIG.BASE_URL || '',
    openapiPath: OPENAPI_PATH,
    groupBy: 'tags',
    hiddenTags: [],
    hiddenOperationIds: [],
    renameTags: {},
    renameOperations: {},
  },
};
